import { useState, useEffect } from 'react';

// Custom hook to manage branch filtering across the application
export function useBranchFilter() {
  const [selectedBranchId, setSelectedBranchId] = useState(() => {
    // Load from localStorage on initialization
    const saved = localStorage.getItem('selectedBranchId');
    return saved ? (saved === 'null' ? null : parseInt(saved)) : null;
  });

  // Add a refresh trigger that changes whenever branch changes
  const [refreshTrigger, setRefreshTrigger] = useState(0);

  // Listen for branch changes from other components via custom events
  useEffect(() => {
    // Listen for custom branchChanged event and sync state
    const handleBranchChanged = (e) => {
      const newBranchId = e.detail?.branchId;
      const currentValue = selectedBranchId;
      
      // Only update if different to avoid unnecessary re-renders
      if (newBranchId !== currentValue) {
        setSelectedBranchId(newBranchId);
      }
    };

    window.addEventListener('branchChanged', handleBranchChanged);

    return () => {
      window.removeEventListener('branchChanged', handleBranchChanged);
    };
  }, [selectedBranchId]);

  useEffect(() => {
    // Save to localStorage whenever it changes
    if (selectedBranchId === null) {
      localStorage.setItem('selectedBranchId', 'null');
    } else {
      localStorage.setItem('selectedBranchId', selectedBranchId.toString());
    }
    
    // Dispatch a custom event to notify all components
    window.dispatchEvent(new CustomEvent('branchChanged', { 
      detail: { branchId: selectedBranchId } 
    }));
    
    // Increment refresh trigger to force re-renders
    setRefreshTrigger(prev => prev + 1);
  }, [selectedBranchId]);

  const handleBranchChange = (branchId) => {
    setSelectedBranchId(branchId);
  };

  return {
    selectedBranchId,
    handleBranchChange,
    refreshTrigger // Export refresh trigger so components can use it
  };
}
